/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function FindingIncoherence({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M15.166 7.168a1.5 1.5 0 0 1-1.078 2.364l-6.322.607a1.5 1.5 0 0 1-1.583-1.917l.075-.198 1.092.498a.3.3 0 0 0 .301.423l6.322-.607a.3.3 0 0 0 .216-.473l-3.687-5.172a.3.3 0 0 0-.517.05l-1.092-.498a1.5 1.5 0 0 1 2.451-.412l.135.164zM7.35 8.522l-1.092-.498 2.635-5.78 1.092.499z" /><path fill="currentColor" d="m.643 10.425.938-3.501a2.474 2.474 0 0 1 3.031-1.75l.453.121a.6.6 0 1 1-.31 1.159l-.453-.122a1.276 1.276 0 0 0-1.562.902L1.8 10.736a1.4 1.4 0 0 0 .99 1.715l3.502.938c.68.182 1.38-.222 1.562-.902l.121-.453a.6.6 0 1 1 1.159.31l-.121.454a2.474 2.474 0 0 1-3.031 1.75l-3.502-.939a2.6 2.6 0 0 1-1.838-3.184" /></svg>;
}
;